import { Component } from '@angular/core';

@Component({
  selector: 'app-page-test',
  standalone: true,
  imports: [],
  templateUrl: './page-test.component.html',
  styleUrl: './page-test.component.scss'
})
export class PageTestComponent {

}
